<template>
  <div>
    <el-card>
      <div class="row-part">
        <el-input
          v-model="searchKeyWord"
          placeholder="文件名"
          style="width: 250px; margin-right: 20px"
        ></el-input>

        <el-upload
          ref="uploadFile"
          :auto-upload="false"
          :http-request="uploadFile"
          :on-change="getUploadFile"
          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .rar, .zip"
          class="upload-btn"
          :file-list="uploadFileList"
          :show-file-list="false"
          v-if="fileAllowRole"
        >
          <el-button type="primary">上传文件</el-button>
        </el-upload>
      </div>

      <el-table
        :data="fileListFilter"
        id="fileTable"
        style="width: 100%"
        height="600"
      >
        <el-table-column label="序号" type="index" width="120" fixed />
        <template v-for="column in fileTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            :formatter="formatter"
            sortable
            :fixed="column.fixed"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button
              size="mini"
              @click.stop="handledownload(scope.$index, scope.row)"
              type="text"
              >下载</el-button
            >
            <el-popconfirm
              title="确认删除?"
              @confirm="handleDelete(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
              v-if="fileAllowRole"
            >
              <template #reference>
                <el-button type="text" size="mini">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import FileBrowse from "../api/FileBrowse";
export default FileBrowse;
</script>

<style scoped lang="scss">
.row-part {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>